import getEnabledItems from '@lyearn/core/utils/array/getEnabledItems';
import { TFunction } from '@lyearn/i18n';
import { CloseOutline, CopyOutline, PinOutline, SmileyOutline, Trash2Outline } from '@lyearn/icons';
import { ActionMenuItemType } from '@lyearn/molecules';
import { ListWithTempId } from '@/hooks/useList/useListWithTempId';
import { getResponseTypeSmallIcon } from '@/modules/corporate/modules/exercise/helpers/getResponseTypeIcon';
import { ExerciseQuestionInput, ResourceResponseTypeEnum } from '@/types/schema';

import { QuestionItemActions, ResponseFormatMenuItem } from '../types';

export const getActionMenuItems = (
  t: TFunction,
  question: ListWithTempId<ExerciseQuestionInput>,
): ActionMenuItemType[] =>
  getEnabledItems([
    {
      label: t('Common:Actions.Duplicate'),
      appearance: 'primary',
      EndIcon: CopyOutline,
      id: QuestionItemActions.Duplicate,
      enabled: true,
    },
    {
      label: t('Exercise:Creator.RemoveImage'),
      appearance: 'primary',
      EndIcon: CloseOutline,
      id: QuestionItemActions.RemoveImage,
      enabled:
        question.responseType === ResourceResponseTypeEnum.ImageHotspot &&
        !!question.medias &&
        question.medias.length > 0,
    },
    {
      label: t('Common:Actions.Delete'),
      appearance: 'danger',
      EndIcon: Trash2Outline,
      id: QuestionItemActions.Delete,
      enabled: true,
    },
  ]) as ActionMenuItemType[];

export const getSubmissionFormats = (t: TFunction): ResponseFormatMenuItem[] => [
  {
    Icon: getResponseTypeSmallIcon(ResourceResponseTypeEnum.Any),
    label: t('Exercise:Creator.ResponseType', { responseType: t('Exercise:Creator.AnyFormat') }),
    value: ResourceResponseTypeEnum.Any,
  },
  {
    Icon: getResponseTypeSmallIcon(ResourceResponseTypeEnum.Text),
    label: t('Exercise:Creator.TextEntry'),
    value: ResourceResponseTypeEnum.Text,
  },
  {
    Icon: getResponseTypeSmallIcon(ResourceResponseTypeEnum.Image),
    label: t('Exercise:Creator.Image'),
    value: ResourceResponseTypeEnum.Image,
  },
  {
    Icon: getResponseTypeSmallIcon(ResourceResponseTypeEnum.Video),
    label: t('Exercise:Creator.VideoRecording'),
    value: ResourceResponseTypeEnum.Video,
  },
  {
    Icon: getResponseTypeSmallIcon(ResourceResponseTypeEnum.Audio),
    label: t('Exercise:Creator.Audio'),
    value: ResourceResponseTypeEnum.Audio,
  },
  {
    Icon: getResponseTypeSmallIcon(ResourceResponseTypeEnum.File),
    label: t('Exercise:Creator.File'),
    value: ResourceResponseTypeEnum.File,
  },
  {
    Icon: PinOutline,
    label: t('Exercise:Creator.ImageHotspot'),
    value: ResourceResponseTypeEnum.ImageHotspot,
  },
  {
    Icon: SmileyOutline,
    label: t('Exercise:Creator.LikertScale'),
    value: ResourceResponseTypeEnum.Likert,
  },
];

export const isQuestionsEmpty = (values?: ExerciseQuestionInput[] | null) => {
  return !values?.length;
};
